import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgEducationIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g stroke="currentColor" strokeWidth={0.441} clipPath="url(#a)">
      <path d="m15.6 21.717.107.058.105-.058 16.04-8.764.354-.193-.354-.194-16.04-8.76-.105-.057-.106.057L-.44 12.57l-.354.194.354.193zm.107-1.692L2.409 12.763l13.298-7.265 13.297 7.262z" />
      <path d="m15.569 29.196.101.052.102-.052 10.9-5.647.119-.062V13.97l-.327.178-10.794 5.88-10.794-5.88-.326-.178v9.514l.119.061 10.9 5.65ZM6.085 16.554l9.48 5.163.105.057.106-.057 9.48-5.163v5.998l-9.586 4.967-9.585-4.967zm23.984-3.99h-.22v7.696h1.534v-7.695H30.07Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEducationIcon;
